(function () {
  var name = new URLSearchParams(window.location.search).get('ime');
  if (!name) return;
  name = name.trim().slice(0, 40);
  if (!name) return;

  var attempts = 0;
  var timer = setInterval(function () {
    attempts += 1;
    var field = document.querySelector('input[type="text"][name^="ymq["]');
    if (field) {
      clearInterval(timer);
      if (!field.value) {
        field.value = name;
        field.dispatchEvent(new Event('input', { bubbles: true }));
        field.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } else if (attempts > 40) {
      clearInterval(timer);
    }
  }, 250);
})();
